import { message } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import Layout from "../../Layout";
import HeaderBread from "../../components/HeaderBread";
import Logs from "../../components/Logs";
import SwitchBar from "../../components/Pages/SwitchBar";
import SearchField from "../../components/SearchField";
import ActiveInactive from "../../components/UI/ActiveInactive";
import CustomizedDragNDrop from "../../components/UI/CustomizedDragNDrop";
import CustomHeaderTitle from "../../components/constants/CustomHeaderTitle";
import DeletePop from "../../constants/ErrorPermissionModal";
import ValidDateUI from "../../constants/validDateUI";
import { addlog } from "../../utils/ApiCalls/Logs";
import {
  deleteSpecialPagesData,
  deleteSpecialPagesDatabulk,
  getSpecialPagesData,
  updatePosition,
  updateSpecialPagesData,
  updateSpecialPagesDataBulk,
} from "../../utils/ApiCalls/SpecialPage";
import { checkPermission } from "../../utils/Validation/checkPermission";
import { getMyZone } from "../../constants/getTimeDate";
import { getAllLocations } from "../../utils/ApiCalls/Locations";
import SelectLocation from "../../components/LocationFilter";
import ActiveSwitchFile from "../../components/SwitchFile";
import { LOG_ACTIONS } from "../../utils/Constant/LogConstant";
const MySwal = withReactContent(Swal);

const SpecialPages = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Special Pages",
      route: "/website/cms/special-pages",
    },
  ];
  const [active, setActive] = useState("listing");
  const [regionalActive, setRegionalActive] = useState("SG");
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [selectedIDs, setSelectedIds] = useState([]);
  const [locationOption, setLocationOption] = useState([]);
  const [sort, setSort] = useState("");
  const [order, setOrder] = useState("");
  const [location, setLocation] = useState();
  const [status, setStatus] = useState("");
  const [bulkStatus, setBulkStatus] = useState(false);
  const [bulkShowHome, setBulkShowHome] = useState(false);
  const [checked, setChecked] = useState(false);
  const [columns, setColumns] = useState([]);
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();

    const locationP = useLocation();
    
      const [page, setPage] = useState(
        () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
      );
      const [pageSize, setPageSize] = useState(
        () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
      );
      const [search, setSearch] = useState(
        () => new URLSearchParams(locationP.search).get("search") || ""
      );
    
      useEffect(() => {
        const params = new URLSearchParams(locationP.search);
        const pageParam = parseInt(params.get("page")) || 1;
        const pageSizeParam = parseInt(params.get("pageSize")) || 10;
        const searchParam = params.get("search") || "";
    
        // setPage(pageParam);
        // setPageSize(pageSizeParam);
        setSearch(searchParam);
      }, [locationP.search]);
    
      useEffect(() => {
        const params = new URLSearchParams();
        const currentParams = new URLSearchParams(locationP.search);
    
        params.set("page", page);
        params.set("pageSize", pageSize);
        if (search) params.set("search", search);
    
        if (currentParams.toString() !== params.toString()) {
          navigate({ search: params.toString() }, { replace: true });
        }
      }, [page, pageSize, search, navigate, locationP.search]);
    
  

  const sortHandler = async (options) => {
    if (Object.keys(options).length > 0) {
      let sort, order;
      sort = options.columnKey;
      order =
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
          ? "desc"
          : undefined;
      setSort(sort);
      setOrder(order);
      await getData(page, sort, order);
    }
  };
  const handleDelete = async (id, title) => {
    if (checkPermission(permission, "delete_per", "Special Pages",window?.location?.pathname)) {
      await deleteSpecialPagesData(id);
      addlog(
        "Special Pages Deleted",
        "Special_Pages",
        { id, title },
        userDetails.id
      );
      await getData(page, sort, order);
    } else {
      message.error("Missing Permission for delete ");
    }
  };
  const handleDeletebulk = async (id, title) => {
    if (checkPermission(permission, "delete_per", "Special Pages",window?.location?.pathname)) {
      await deleteSpecialPagesDatabulk(id);
      addlog(
        "bulk Special Pages Deleted",
        "Special_Pages",
        { id, title },
        userDetails.id
      );
      setBulkShowHome(false);
      setBulkStatus(false);
      setSelectedIds([]);
      await getData(page, sort, order);
    } else {
      message.error("Missing Permission for delete ");
    }
  };

  useEffect(() => {
    getData(page);
  }, [page, pageSize, search]);
  useEffect(() => {
    getLocationData();
  }, []);
  const getLocationData = async () => {
    let data = await getAllLocations();
    setLocationOption(data?.data || []);
  };
  useEffect(() => {
    if (locationOption.length > 0) {
      setChecked(false)
      setColumns([
        {
          title: (
            <div style={{ fontSize: "1.2rem" }}>
              <input
                type="checkbox"
                value={checked}
                onChange={(e) => {
                  setChecked(e.target.checked);
                  if (e.target.checked) {
                    let val = selectedIDs;
                    rows.map((item) => {
                      if (!val.includes(item.id)) {
                        val.push(item.id);
                      }
                    });
                    setSelectedIds(val);
                  } else {
                    let val = selectedIDs;
                    rows.map((item) => {
                      if (val.includes(item.id)) {
                        val = val.filter((val) => val != item.id);
                      }
                    });
                    setSelectedIds(val);
                  }
                }}
                id={`checkbox-all`}
              />
            </div>
          ),
          dataIndex: "id",
          width: 20,
          key: "id",
          render: (text, record, index) => (
            <div style={{ fontSize: "1.2rem" }}>
              <input
                type="checkbox"
                checked={selectedIDs.includes(record.id)}
                onChange={(e) => {
                  if (e.target.checked)
                    setSelectedIds((item) => [...item, record.id]);
                  else {
                    setSelectedIds(
                      selectedIDs.filter((item) => item !== record.id)
                    );
                  }
                }}
                id={`checkbox${record.id}`}
              />
            </div>
          ),
        },
        {
          title: "Sl",
          dataIndex: "id",
          width: 100,
          key: "id",
          render: (text, record, index) => (page - 1) * pageSize + index + 1,
        },

        {
          title: "Title",
          dataIndex: "english_display_title",
          key: "english_display_title",
          render: (item) => {
            let value = item.split("-");
            if (value && value.length > 1)
              return value.slice(0, value.length - 1).join("-");
            else return value.join("");
          },
          sorter: (a, b) => "",
        },
        {
          title: "Vessel",
          dataIndex: "vessel_name",
          key: "vessel",

          render: (item) => item.name,
        },
        {
          title: "Market Code",
          dataIndex: "agency",
          key: "agency",

          render: (item) => item?.marketCode,
        },

        {
          title: "Valid date",
          dataIndex: "valid_date",
          key: "valid_till",

          render: (text, record, index) => {
            return (
              <ValidDateUI
                regionalActive={regionalActive}
                locationOption={locationOption}
                time
                record={record}
                handleUpdate={handleUpdate}
              />
            );
          },
        },
        {
          title: "Status",
          dataIndex: "is_active",
          key: "is_active",
          sorter: (a, b) => "",
          render: (item, record, index) => (
            <ActiveSwitchFile
              module={"Special Page"}
              item={item}
              record={record}
              index={index}
              handleUpdate={handleUpdate}
            />
          ),
        },
        {
          title: "Show Home",
          dataIndex: "show_home",
          key: "show_home",
          sorter: (a, b) => "",
          render: (item, record, index) => {
            return (
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  checked={item}
                  onChange={(value) => {
                    try {
                      handleUpdate(
                        record.id,
                        {
                          show_home: value.target.checked ? 1 : 0,
                        },
                        record.title
                      );
                    } catch (error) {
                      dispatch({
                        type: "SET_LOADING",
                        loading: false,
                      });

                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: error.message,
                      });
                    }
                  }}
                  className="custom-control-input"
                  id={"customSwitch1-show" + index}
                />
                <label
                  className="custom-control-label"
                  style={{}}
                  htmlFor={"customSwitch1-show" + index}
                ></label>
              </div>
            );
          },
        },

        {
          title: "Action",
          key: "operation",

          render: (text, record) => (
            <div className="table_action_btn">
              <button className="btn" onClick={() => handleEdit(record.id)}>
                <i
                  className="ri-edit-2-line"
                  data-toggle="tooltip"
                  title="Edit"
                ></i>
              </button>
              <DeletePop
                onConfirm={() => handleDelete(record.id, record.title)}
              >
                <div>
                  {" "}
                  <button className="btn delete_btn">
                    <i
                      className="ri-delete-bin-line"
                      data-toggle="tooltip"
                      title="Delete"
                    ></i>
                  </button>
                </div>
              </DeletePop>

              <div
                onClick={async () => {
                  try {
                    navigator.clipboard
                      .writeText(`${record.url}`)
                      .then(() => {
                        alert("successfully copied");
                      })
                      .catch(() => {
                        alert("something went wrong");
                      });
                  } catch (error) {
                    console.error("Error copying to clipboard:", error);
                  }
                }}
                className="btn copy_btn"
              >
                <span data-toggle="tooltip" title="Copy Url">
                  Copy Url
                </span>
              </div>
            </div>
          ),
        },
      ]);
    }
  }, [
    locationOption,
    page,
    pageSize,
    regionalActive,
    location,
    status,
    selectedIDs,
    search,
    active,
    rows,
  ]);
  useEffect(() => {
    getData(page);
  }, [regionalActive]);

  const updateDealPosition = async (pages) => {
    if (checkPermission(permission, "update_per", "Special Pages",window?.location?.pathname)) {
      try {
        let args = { search: search, page: page, limit: pageSize };

        if (regionalActive) {
          args = { ...args, location: regionalActive };
        }
        if (status !== "") {
          args = { ...args, is_active: status };
        }
        /*Later*/
        // }
        // if (order) {
        //   if (sort) {
        //     args = { ...args, sort };
        //   }
        //   args = { ...args, order };
        // }
        const data = await updatePosition(pages, args);
        // addlog(
        //   "Deal Position Updated",
        //   "Deal",
        //   { location_id:deals[0].location_id },
        //   userDetails.id
        // );
        if (data.error)
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.error,
          });
        else if (data.data) {
          setRows(data.data);
          setCount(data.count);
          // setPositionalValue(data.data);
        }
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
      } catch (error) {
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        // dispatch({
        //   type: "SET_ERROR_MESSAGE",
        //   errMess: {
        //     message: error.message || "Unknown error occurred",
        //     type: "error",
        //   },
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message || "Unknown error occurred",
        });
      }
    } else {
      message.error("Update permission missing");
    }
  };

  const getData = async (value, sort, order) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let args = { search: search, page: value, limit: pageSize };

    if (regionalActive) {
      args = { ...args, location: regionalActive };
    }
    if (location && location != -1) {
      args = { ...args, location_id: location };
    }
    if (status !== "") {
      args = { ...args, is_active: status };
    }
    if (order) {
      if (sort) {
        args = { ...args, sort };
      }
      args = { ...args, order };
    }
    let data = await getSpecialPagesData(args);
    if (data.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const handleEdit = async (id) => {
    if (checkPermission(permission, "update_per", "Special Pages",window?.location?.pathname)) {
      navigate("/website/cms/special-pages/edit/" + id);
    } else {
      message.error("Update permission missing");
    }
  };

  const handleUpdate = async (id, values, title) => {
    if (checkPermission(permission, "update_per", "Special Pages",window?.location?.pathname)) {
      let data = await updateSpecialPagesData(id, values);
      if (data.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
      } else {
        addlog(
          "Special Pages " +
            (values.is_active !== undefined
              ? values.is_active === 1
                ? LOG_ACTIONS.ACTIVATED
                : LOG_ACTIONS.DEACTIVATED
              : LOG_ACTIONS.UPDATED),
          "Special_Pages",
          { ...values, id, title },
          userDetails.id
        );
      }
      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };
  const handleUpdateBulk = async (id, values, title) => {
    if (checkPermission(permission, "update_per", "Special Pages",window?.location?.pathname)) {
      let data = await updateSpecialPagesDataBulk(id, values);
      if (data.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
      } else {
        addlog(
          "Bulk Special Pages " +
            (values.is_active !== undefined
              ? values.is_active === 1
                ? LOG_ACTIONS.ACTIVATED
                : LOG_ACTIONS.DEACTIVATED
              : LOG_ACTIONS.UPDATED),
          "Special_Pages",
          { ...values, id, title },
          userDetails.id
        );
      }

      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };

  return (
    <Layout type={"read_per"} module_data={"Special Pages"}>
      <CustomHeaderTitle title={"Special Pages"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Special Pages"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Special Pages List", value: "listing" },
                { value: "logs", title: " History Logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Special Pages List</h5>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "5px",
                      width: "80%",
                      justifyContent: "flex-end",
                    }}
                  >
                    {regionalActive == "OTHER" && (
                      <SelectLocation
                        getData={getData}
                        setStatus={setLocation}
                        disabled={regionalActive == "OTHER"}
                        status={location}
                        width={200}
                        setPage={setPage}
                      />
                    )}
                    <ActiveInactive
                      width={200}
                      getData={getData}
                      setStatus={setStatus}
                      status={status}
                      setPage={setPage}
                    />
                    <Link to="/website/cms/special-pages/add" className="btn add_v_btn">
                      Add Pages
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      {selectedIDs?.length > 0 && (
                        <div
                          style={{
                            marginRight: "auto",
                            border: "1px solid lightgray",
                            marginBottom: "10px",

                            borderRadius: "5px",
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            padding: "5px",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              borderRight: "1px solid lightgray",
                              padding: "5px 10px",
                              flex: 1,
                              width: "100px",
                            }}
                          >
                            {" "}
                            <p style={{ fontWeight: "bold", color: "red" }}>
                              {selectedIDs?.length}
                            </p>{" "}
                            <p>records</p>{" "}
                          </div>
                          <div
                            style={{
                              padding: "5px 10px",
                              borderRight: "1px solid lightgray",
                              width: "100px",
                            }}
                          >
                            <label>Status</label>
                            <div className="custom-control custom-switch">
                              <input
                                type="checkbox"
                                value={bulkStatus}
                                onChange={(e) => {
                                  const newStatus = e.target.checked ? 1 : 0;
                                  setBulkStatus(e.target.value);
                                  try {
                                    handleUpdateBulk(selectedIDs, {
                                      is_active: newStatus,
                                    });
                                  } catch (error) {}
                                }}
                                className="custom-control-input"
                                id={`customSwitch_active`}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`customSwitch_active`}
                              ></label>
                            </div>
                          </div>
                          <div
                            style={{
                              borderRight: "1px solid lightgray",
                              padding: "5px 10px",
                              width: "100px",
                            }}
                          >
                            <label>Show Home</label>
                            <div className="custom-control custom-switch">
                              <input
                                type="checkbox"
                                value={bulkShowHome}
                                onChange={(e) => {
                                  const newStatus = e.target.checked ? 1 : 0;
                                  setBulkShowHome(e.target.value);
                                  try {
                                    handleUpdateBulk(selectedIDs, {
                                      show_home: newStatus,
                                    });
                                  } catch (error) {}
                                }}
                                className="custom-control-input"
                                id={`customSwitch_active_home`}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`customSwitch_active_home`}
                              ></label>
                            </div>
                          </div>
                          <div
                            style={{
                              padding: "5px 10px",
                              display: "flex",
                              alignItems: "center",
                              width: "100px",
                              textAlign: "center",
                              flexDirection: "column",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <label>Delete</label>
                            <DeletePop
                              onConfirm={() => handleDeletebulk(selectedIDs)}
                            >
                              {" "}
                              <button
                                className="btn delete_btn"
                                style={{ marginTop: "-10px", color: "red" }}
                              >
                                <i
                                  className="ri-delete-bin-line"
                                  data-toggle="tooltip"
                                  title="Delete"
                                ></i>
                              </button>
                            </DeletePop>
                          </div>
                        </div>
                      )}
                      <div style={{ maxWidth: 200 }}>
                        <SearchField
                          value={search}
                          SearchValue={() => {
                            setPage(page);
                          }}
                          setValue={(e) => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <SwitchBar
                      tabs={[
                        { title: "Singapore", value: "SG" },
                        { value: "MY", title: "Malaysia" },
                        { value: "ID", title: "Indonesia" },
                        { value: "IN", title: "India" },
                        { value: "CN", title: "China" },
                        { value: "TW", title: "Taiwan" },
                        { value: "HK", title: "Hong Kong" },
                        { value: "PH", title: "Philippines" },
                        { value: "AE", title: "UAE" },
                        { value: "OTHER", title: "All Others" },
                      ]}
                      module={"country-tab"}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      setRows={setRows}
                      setCount={setCount}
                      activeTab={regionalActive}
                      setActiveTab={(item) => {
                        setRegionalActive(item);
                        setLocation();
                      }}
                      setSearch={setSearch}
                    />
                    {rows && (
                      <CustomizedDragNDrop
                        setRows={setRows}
                        setPageSize={setPageSize}
                        setPage={setPage}
                        pageSize={pageSize}
                        page={page}
                        count={count}
                        columns={columns}
                        rows={rows}
                        sortHandler={sortHandler}
                        title={"Special Pages"}
                        updatePosition={updateDealPosition}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "logs" && (
          <Logs
            type={"Special_Pages"}
            slug={"/website/cms/special-pages/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};

export default SpecialPages;
